import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ativoManutencaoProximoCodigo } from '~/Services/Service';
import FormAtivo from '~/Pages/AtivoManutencao/components/FormAtivo';

// Paridade UImobilizado.pas:858-877 — SpeedButton2Click abre TManutAtivo
// com Tag=2, que força tipos_ativo='1' (Imobilizado). O form completo
// exige Família/Variante/Qualidade/Moeda Padrão — iguais ao Delphi.
const ModalNovoAtivo = ({ show, onFechar, onSalvar }) => {
  const [ativoInicial, setAtivoInicial] = useState(null);

  useEffect(() => {
    if (!show) {
      setAtivoInicial(null);
      return undefined;
    }
    let ativo = true;
    ativoManutencaoProximoCodigo()
      .then((resp) => {
        if (!ativo) return;
        setAtivoInicial({
          codigo_ativo: resp && resp.codigo ? resp.codigo : 0,
          _novo: true,
          tipos_ativo: '1',
          status: '0',
        });
      })
      .catch(() => {
        if (ativo) {
          toast.error('Erro ao gerar próximo código do ativo.');
          if (onFechar) onFechar();
        }
      });
    return () => { ativo = false; };
  }, [show, onFechar]);

  const handleSalvar = (codigoAtivo, values) => {
    const nome = (values && values.nome) ? values.nome : '';
    const label = `${codigoAtivo} — ${nome}`.trim();
    if (onSalvar) onSalvar({ value: codigoAtivo, label });
  };

  if (!show || !ativoInicial) return null;

  return (
    <FormAtivo
      show={show}
      ativo={ativoInicial}
      onSalvar={handleSalvar}
      onCancelar={onFechar}
    />
  );
};

export default ModalNovoAtivo;
